import { Routes } from '@angular/router';
import { MainContentComponent } from './layout/main-content/main-content.component';
import { UsersComponent } from './components/users/users.component';
import { AddUserComponent } from './components/users/add-user/add-user.component';
import { AddMemberComponent } from './components/members/add-member/add-member.component';
import { MembersComponent } from './components/members/members.component';
import { MemberSingleComponent } from './components/members/member-single/member-single.component';
import { InventoryComponent } from './components/inventory/inventory.component';
import { AddInventoryComponent } from './components/inventory/add-inventory/add-inventory.component';
import { SalesComponent } from './components/sales/sales.component';
import { AddSalesComponent } from './components/sales/add-sales/add-sales.component';
import { AuthGuard } from './core/guards/auth.guard';
import { AttendanceComponent } from './components/attendance/attendance.component';
import { AddAttendanceComponent } from './components/attendance/add-attendance/add-attendance.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { AddPaymentComponent } from './components/payments/add-payment/add-payment.component';
import { AnnouncementsComponent } from './components/announcements/announcements.component';
import { AddAnnouncementComponent } from './components/announcements/add-announcement/add-announcement.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { CardPaymentAddComponent } from './components/payments/card-payment-add/card-payment-add.component';
import { LogsComponent } from './components/logs/logs.component';
import { LoginGuard } from './core/guards/login.guard';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/auth/auth.module').then((m) => m.AuthModule),
  },
  // App Components
  {
    path: '',
    redirectTo: '/auth/login',
    pathMatch: 'full',
  },
  {
    path: 'member',
    component: MainContentComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/member/profile',
        pathMatch: 'full',
      },
      {
        path: 'profile',
        component: MemberSingleComponent,
      },
      {
        path: 'members/add-edit',
        component: AddMemberComponent,
      },
      {
        path: 'card-pay/:id',
        component: CardPaymentAddComponent,
      },
      {
        path: 'card-pay',
        component: CardPaymentAddComponent,
      },
    ],
  },
  {
    path: 'admin',
    component: MainContentComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: '',
        redirectTo: '/admin/users',
        pathMatch: 'full',
      },
      {
        path: 'users',
        component: UsersComponent,
      },
      {
        path: 'users/add-edit',
        component: AddUserComponent,
      },
      {
        path: 'users/add-edit/:id',
        component: AddUserComponent,
      },
      {
        path: 'members/add-edit',
        component: AddMemberComponent,
      },
      {
        path: 'members/add-edit/:id',
        component: AddMemberComponent,
      },
      {
        path: 'members',
        component: MembersComponent,
      },
      {
        path: 'view-member/:id',
        component: MemberSingleComponent,
      },
      {
        path: 'attendance',
        component: AttendanceComponent,
      },
      {
        path: 'attendance/add-edit',
        component: AddAttendanceComponent,
      },
      {
        path: 'payments',
        component: PaymentsComponent,
      },
      {
        path: 'payment/add-edit',
        component: AddPaymentComponent,
      },
      {
        path: 'payment/add-edit/:id',
        component: AddPaymentComponent,
      },
      {
        path: 'announcements',
        component: AnnouncementsComponent,
      },
      {
        path: 'announcement/add-edit',
        component: AddAnnouncementComponent,
      },
      {
        path: 'inventory',
        component: InventoryComponent,
      },
      {
        path: 'inventory/add-edit/:id',
        component: AddInventoryComponent,
      },
      {
        path: 'inventory/add-edit',
        component: AddInventoryComponent,
      },
      {
        path: 'sales',
        component: SalesComponent,
      },
      {
        path: 'sales/add-edit',
        component: AddSalesComponent,
      },
      {
        path: 'sales/add-edit/:id',
        component: AddSalesComponent,
      },
      {
        path: 'logs',
        component: LogsComponent,
      },
    ],
  },
  {
    path: 'not-found',
    component: NotFoundComponent,
  },
  { path: '**', redirectTo: '/not-found' },
];
